import React from "react";
import "./faqs.scss";
import Accordion from "react-bootstrap/Accordion";
import Navbar from "../landing/header/Navbar";
import Footer from "../landing/Footer/Footer";

const Faqs = () => {
  return (
    <>
    <Navbar />
      <section className="inner_faqs">
        <div className="custom-container">
          <div className="parent_faqs">
            <h2>Frequently Asked Questions</h2>
            <p>
              Find answers to common questions about buying and managing GEMS
              tokens.
            </p>
            <div className="accordians_main_div">
              <Accordion defaultActiveKey="0">
                <Accordion.Item eventKey="0">
                  <Accordion.Header>
                    <span>01.</span>How do I buy GEMS tokens?
                  </Accordion.Header>
                  <Accordion.Body>
                    To buy GEMS tokens, specify the amount of ETH you wish to
                    exchange, accept the terms, and select "Buy $GEMS". Confirm
                    the transaction in your linked wallet. Ensure you have
                    sufficient ETH to cover both the token purchase and any
                    associated gas fees.
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="1">
                  <Accordion.Header>
                    <span>02.</span>What networks are supported?
                  </Accordion.Header>
                  <Accordion.Body>
                    To buy GEMS tokens, specify the amount of ETH you wish to
                    exchange, accept the terms, and select "Buy $GEMS". Confirm
                    the transaction in your linked wallet. Ensure you have
                    sufficient ETH to cover both the token purchase and any
                    associated gas fees.
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="2">
                  <Accordion.Header>
                    <span>03.</span>When will I receive my tokens?
                  </Accordion.Header>
                  <Accordion.Body>
                    To buy GEMS tokens, specify the amount of ETH you wish to
                    exchange, accept the terms, and select "Buy $GEMS". Confirm
                    the transaction in your linked wallet. Ensure you have
                    sufficient ETH to cover both the token purchase and any
                    associated gas fees.
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="3">
                  <Accordion.Header>
                    <span>04.</span>Are there any restrictions?
                  </Accordion.Header>
                  <Accordion.Body>
                    To buy GEMS tokens, specify the amount of ETH you wish to
                    exchange, accept the terms, and select "Buy $GEMS". Confirm
                    the transaction in your linked wallet. Ensure you have
                    sufficient ETH to cover both the token purchase and any
                    associated gas fees.
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="4">
                  <Accordion.Header>
                    <span>05.</span>What is the minimum purchase amount?
                  </Accordion.Header>
                  <Accordion.Body>
                    To buy GEMS tokens, specify the amount of ETH you wish to
                    exchange, accept the terms, and select "Buy $GEMS". Confirm
                    the transaction in your linked wallet. Ensure you have
                    sufficient ETH to cover both the token purchase and any
                    associated gas fees.
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="5">
                  <Accordion.Header>
                    <span>06.</span>How do I connect my wallet?
                  </Accordion.Header>
                  <Accordion.Body>
                    To buy GEMS tokens, specify the amount of ETH you wish to
                    exchange, accept the terms, and select "Buy $GEMS". Confirm
                    the transaction in your linked wallet. Ensure you have
                    sufficient ETH to cover both the token purchase and any
                    associated gas fees.
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="6">
                  <Accordion.Header>
                    <span>07.</span>What happens if the transaction fails?
                  </Accordion.Header>
                  <Accordion.Body>
                    To buy GEMS tokens, specify the amount of ETH you wish to
                    exchange, accept the terms, and select "Buy $GEMS". Confirm
                    the transaction in your linked wallet. Ensure you have
                    sufficient ETH to cover both the token purchase and any
                    associated gas fees.
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="7">
                  <Accordion.Header>
                    <span>08.</span>Can I purchase with other cryptocurrencies?
                  </Accordion.Header>
                  <Accordion.Body>
                    To buy GEMS tokens, specify the amount of ETH you wish to
                    exchange, accept the terms, and select "Buy $GEMS". Confirm
                    the transaction in your linked wallet. Ensure you have
                    sufficient ETH to cover both the token purchase and any
                    associated gas fees.
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="8">
                  <Accordion.Header>
                    <span>09.</span>Is there a maximum purchase limit?
                  </Accordion.Header>
                  <Accordion.Body>
                    To buy GEMS tokens, specify the amount of ETH you wish to
                    exchange, accept the terms, and select "Buy $GEMS". Confirm
                    the transaction in your linked wallet. Ensure you have
                    sufficient ETH to cover both the token purchase and any
                    associated gas fees.
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="9">
                  <Accordion.Header>
                    <span>10.</span>How can I verify my transaction?
                  </Accordion.Header>
                  <Accordion.Body>
                    To buy GEMS tokens, specify the amount of ETH you wish to
                    exchange, accept the terms, and select "Buy $GEMS". Confirm
                    the transaction in your linked wallet. Ensure you have
                    sufficient ETH to cover both the token purchase and any
                    associated gas fees.
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
};

export default Faqs;
